module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-44.cf871511.png";